import styled from 'styled-components';

export const TR = styled.tr`
  text-align: center;
  text-transform: uppercase;
`;
